import { render, staticRenderFns } from "./PagerItem.vue?vue&type=template&id=7e20112e&scoped=true&"
import script from "./PagerItem.vue?vue&type=script&lang=js&"
export * from "./PagerItem.vue?vue&type=script&lang=js&"
import style0 from "./PagerItem.vue?vue&type=style&index=0&id=7e20112e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e20112e",
  null
  
)

export default component.exports